import { render, staticRenderFns } from "./ProjectNotShared.vue?vue&type=template&id=79919517&scoped=true&"
import script from "./ProjectNotShared.vue?vue&type=script&lang=ts&"
export * from "./ProjectNotShared.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectNotShared.vue?vue&type=style&index=0&id=79919517&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79919517",
  null
  
)

export default component.exports